import React, {useEffect} from 'react';
import {MainTop} from "../../../groups/group-container/main-top/Main-top";
import {ReactComponent as ArrayIcon} from '../../../../../assets/main/groups/main-top/back.svg';
import {CheckContainer} from "./check-container/check-container";
import {useAppDispatch, useAppSelector} from "../../../../../common/hook";
import {Navigate, useParams} from "react-router-dom";
import AuthWrapper from "../../../../auth-wrapper/AuthWrapper";
import {
    fetchCourseById
} from "../../../../../features/model/service/courses/curses-by/get-curses-by-id/fetchCourseById";

export const CheckOut = () => {
    const authData = useAppSelector(state => state.user.authData);
    const dispatch = useAppDispatch();
    const { curseId } = useParams();


    useEffect(() => {
        dispatch(fetchCourseById(curseId));
    }, [dispatch, curseId]);

    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Оформить покупку'} tabs={false} setting={false} link={'/buy-course'} icons={<ArrayIcon/>}/>
                <CheckContainer/>
            </div>
        </AuthWrapper>
    );
};

